<template>
    <div class='container'>
        <h1 class="title">防詐騙公告</h1>
        <div class="instructions" v-for="item in getfooter" :id=item.name v-if="item.name === '防诈骗公告'">
            <div class="instructionses" v-html="item.content"></div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
    components: {},
    data() {
        return {
            webmeta: {
                og_title: '',
                illustrate_title: '',
                illustrate_description: ''
            }
        };
    },
    computed: {
        ...mapState('header', ['getfooter', 'cate', 'website', 'getnav', 'seo']),
    },
    watch: {},
    metaInfo() {
        return {
            title: '防詐騙公告',
            meta: [
                // { vmid: 'description', name: 'description', content: this.webmeta.illustrate_description },
            ]
        }
    },
    methods: {
    },
    created() {
    },
    mounted() {
    },
}
</script>
<style lang='scss'>
h1 {
    text-align: center;
}

.instructions {

    // text-align: center;
    ul {
        margin: 0;
        padding: 0;
        list-style: none;

        li {
            margin: 0;
            padding: 0;
        }
    }

    .instructionses {

        p {
            margin: 0 !important;
        }

        img {
            display: block;
        }
    }
}
</style>
<style lang='scss' scoped src="./index.scss"></style>
